module.exports = __webpack_public_path__ + "static/media/26.904bcf72.jpg";